/* Postavka menija "Obvestila" s pikico neprebranega.
   [PATCH objave-fe v1]

   Lastna komponenta NAMENOMA: `navKoncni` se v DashboardLayout gradi v vrstici
   ~65, `location` pa nastane sele v ~74 — vrivanje stanja v navKoncni bi zadelo
   v casovno mrtvo cono. Isti razlog kot pri NapakeNavPostavka.

   PIKICA, NE STEVILO (zahteva 23.07.2026): pri odprtem sidebaru stoji desno
   namesto stevca, pri zaprtem pa v kotu ikone — enako kot pri Napakah.

   Videz je znak za znak enak ostalim postavkam menija (razredi prepisani iz
   NapakeNavPostavka, ki jih je prevzel iz DashboardLayout). */
import React, { useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Megaphone } from 'lucide-react';
import clsx from 'clsx';
import { useObjaveStore } from '../stores/objaveStore';

export function ObvestilaNavPostavka({ sidebarOpen }: { sidebarOpen: boolean }) {
  const neprebrano = useObjaveStore((s) => s.neprebrano);
  const nalozi = useObjaveStore((s) => s.nalozi);
  const location = useLocation();

  /* ob vsaki menjavi rute */
  useEffect(() => { nalozi(); }, [location.pathname, nalozi]);

  /* anketa 60 s — objave so redke, 20 s kot pri napakah bi bilo odvec */
  useEffect(() => {
    const t = setInterval(() => { nalozi(); }, 60000);
    return () => clearInterval(t);
  }, [nalozi]);

  /* takojsnja osvezitev ob vrnitvi v zavihek ali okno */
  useEffect(() => {
    const osvezi = () => {
      if (document.visibilityState === 'visible') nalozi();
    };
    window.addEventListener('focus', osvezi);
    document.addEventListener('visibilitychange', osvezi);
    return () => {
      window.removeEventListener('focus', osvezi);
      document.removeEventListener('visibilitychange', osvezi);
    };
  }, [nalozi]);

  return (
    <NavLink to="/obvestila"
      className={({ isActive }) => clsx(
        'flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-all',
        isActive
          ? 'bg-blue-50 dark:bg-blue-950 text-blue-600 dark:text-blue-400'
          : 'text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 hover:text-gray-900 dark:hover:text-white'
      )}>
      <span className="relative flex-shrink-0">
        <Megaphone className="w-5 h-5" />
        {!sidebarOpen && neprebrano && (
          <span className="absolute -top-1 -right-1 w-2 h-2 bg-blue-500 rounded-full" />
        )}
      </span>
      {sidebarOpen && (
        <>
          <span>Obvestila</span>
          {neprebrano && (
            <span className="ml-auto w-2 h-2 bg-blue-500 rounded-full flex-shrink-0" />
          )}
        </>
      )}
    </NavLink>
  );
}
